import React from 'react';
import PropTypes from 'prop-types';
import ThankYouImage from '../../../images/thank_you.png';
import './ReceivedVehicleModal.scss';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const ReceivedVehicleModal = ({ t, closeModal, }) => {
  return (
    <div>
      <img alt="thank_you_image" src={ThankYouImage} />
      <div className="received-vehicle-modal__intro">{t('thanks_for_business')}</div>
      <div className="received-vehicle-modal__body">{t('body')}</div>
      <div className="submit-area">
        <button type="submit" className="submit-button" onClick={closeModal}>{t('got_it')}</button>
      </div>
    </div>
  );
};

ReceivedVehicleModal.propTypes = {
  t: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};


export default withScopedTranslations('received_vehicle_modal')(ReceivedVehicleModal);
